'use client';

import React from 'react';
import { Flex, type BoxProps } from '@shared/ui';

interface SectionStackProps extends BoxProps {
    children: React.ReactNode | React.ReactNode[];
}

export const SectionStack: React.FC<SectionStackProps> = (props) => {
    const { children, flexDirection = 'column', ...rest } = props;

    return (
        <Flex
            flexDirection={flexDirection}
            gap={{
                sm: 'm',
                md: 'xl',
            }}
            align="stretch"
            {...rest}
        >
            {children}
        </Flex>
    );
};

export type SectionStackReturn = ReturnType<typeof SectionStack>;
